import { getAllKnownBrands } from '@/redux/actions/brand.actions';
import { getAllCategories } from '@/redux/actions/category.actions';
import Link from 'next/link';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const GlobalCalls = () => {
	const dispatch = useDispatch();

	const categories = useSelector(
		(state) => state.categoryReducer.allCategories
	);

	useEffect(() => {
		dispatch(getAllCategories());
		dispatch(getAllKnownBrands());
	}, []);

	return (
		<div className='fixed top-0 left-0 w-full h-full z-[-1] opacity-0'>
			{categories?.map((cat, i) => (
				<Link href={`/categories/${cat?.categoryId}`}>{cat?.name}</Link>
			))}
		</div>
	);
};

export default GlobalCalls;
